import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import S3FileUpload from "react-s3";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

const Aboutus = (props) => {
  const [isEmpty, setIsEmpty] = useState(false);
  const [introImage, setIntroImage] = useState(null);
  const [story_image, setStoryImage] = useState(null);
  const [missionImage, setMissionImage] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [timeline, setTimeline] = useState([
    {
      year: "",
      title: "",
    },
  ]);
  const [values, setValues] = useState([
    {
      title: "",
      description: "",
    },
  ]);
  const [awards, setAwards] = useState([
    {
      year: "",
      title: "",
    },
  ]);
  const [offices, setOffices] = useState([
    {
      title: "",
      address: "",
      image: "",
      phone: "",
      email: "",
    },
  ]);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const allFields = watch();

  const user = useSelector((state) => state.User);

  // get about us page details
  const aboutPageDetails = () => {
    setIsLoading(true);
    apiReq(url.GET_ABOUTUS, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("title", res.data.title);
          setValue("description", res.data.description);
          setValue("story_title", res.data.story_title);
          setIntroImage(res.data.introImage);
          setValue("stroy_description", res.data.stroy_description);
          setStoryImage(res.data.story_image);
          setTimeline(res.data.timeline);
          setValue("mission_title", res.data.mission_title);
          setValue("mission_description", res.data.mission_description);
          setMissionImage(res.data.mission_image);
          setValue("values_title", res.data.values_title);
          setValues(res.data.values);
          setValue("team_title", res.data.team_title);
          setValue("team_description", res.data.team_description);
          // setValue("award_title", res.data.award_title);
          // setValue("award_description", res.data.award_description);
          // setAwards(res.data.awards);
          setValue("customer_title", res.data.customer_title);
          setCustomers(res.data.customers);
          setValue("office_title", res.data.office_title);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);
          setOffices(res.data.offices);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };
  const getDashboardDetails = () => {
    setIsLoading(true);
    apiReq(url.GET_DASHBOARD_DETAILS, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    });
  };

  useEffect(() => {
    aboutPageDetails();
    getDashboardDetails();
  }, []);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // AWS Config
  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    // dirName: "downloads",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // Todo: Intro section
  // uploadIntroImage
  const uploadIntroImage = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, { ...config, dirName: "aboutus" })
      .then((data) => {
        setIntroImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };
  // uploadStoryImage
  const uploadStoryImage = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, { ...config, dirName: "aboutus" })
      .then((data) => {
        setStoryImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };
  // uploadMissionImage
  const uploadMissionImage = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, { ...config, dirName: "aboutus" })
      .then((data) => {
        setMissionImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  //uploadCutomerImage
  const uploadCutomerImage = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, { ...config, dirName: "customers" })
      .then((data) => {
        setCustomers([
          ...customers,
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`,
        ]);
      })
      .catch((err) => console.log(err));
  };

  // Todo: Time line
  // handleTimeLineInput
  const handleTimeLineInput = (event, index) => {
    const { name, value } = event.target;
    const newTimeline = [...timeline];
    newTimeline[index][name] = value;
    setTimeline(newTimeline);
  };

  // removeTimeLine
  const removeTimeLine = (index) => {
    const newTimeline = [...timeline];
    newTimeline.splice(index, 1);
    setTimeline(newTimeline);
  };

  // addTimeLine
  const addTimeLine = () => {
    setTimeline([...timeline, { year: "", title: "" }]);
  };

  // Todo: Values
  // handleValuesInput
  const handleValuesInput = (event, index) => {
    const { name, value } = event.target;
    const newValues = [...values];
    newValues[index][name] = value;
    setValues(newValues);
  };

  // removeValues
  const removeValues = (index) => {
    const newValues = [...values];
    newValues.splice(index, 1);
    setValues(newValues);
  };

  // addValues
  const addValues = () => {
    setValues([...values, { title: "", description: "" }]);
  };

  // Todo: Awards
  // handleAwardsInput
  const handleAwardsInput = (event, index) => {
    const { name, value } = event.target;
    const newAwards = [...awards];
    newAwards[index][name] = value;
    setAwards(newAwards);
  };
  // removeAwards
  const removeAwards = (index) => {
    const newAwards = [...awards];
    newAwards.splice(index, 1);
    setAwards(newAwards);
  };

  // addAward
  const addAward = () => {
    setAwards([...awards, { year: "", title: "" }]);
  };

  // Todo: Customer
  // handleRemoveCustomer
  const handleRemoveCustomer = (index) => {
    const newCustomers = [...customers];
    newCustomers.splice(index, 1);
    setCustomers(newCustomers);
  };

  // Todo: Offices
  // removeOffice
  const removeOffice = (index) => {
    const newOffices = [...offices];
    newOffices.splice(index, 1);
    setOffices(newOffices);
  };

  // uploadOfficeImage
  const uploadOfficeImage = (event, index) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, { ...config, dirName: "offices" })
      .then((data) => {
        const newOffices = [...offices];
        newOffices[
          index
        ].image = `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`;
        setOffices(newOffices);
      })
      .catch((err) => console.log(err));
  };

  // handleOfficesInput
  const handleOfficesInput = (event, index) => {
    const { name, value } = event.target;
    const newOffices = [...offices];
    newOffices[index][name] = value;
    setOffices(newOffices);
  };

  // addOffice
  const addOffice = () => {
    setOffices([
      ...offices,
      { title: "", address: "", image: "", phone: "", email: "" },
    ]);
  };

  // RemoveOfficeImage
  const removeOfficeImage = (index) => {
    const newOffices = [...offices];
    newOffices[index].image = "";
    setOffices(newOffices);
  };

  const onSubmit = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_ABOUTUS,
        {
          title: data.title,
          description: data.description,
          introImage: introImage,
          story_title: data.story_title,
          stroy_description: data.stroy_description,
          story_image: story_image,
          timeline: timeline,
          mission_title: data.mission_title,
          mission_description: data.mission_description,
          mission_image: missionImage,
          values_title: data.values_title,
          values: values,
          team_title: data.team_title,
          team_description: data.team_description,
          // award_title: data.award_title,
          // award_description: data.award_description,
          // awards: awards,
          customer_title: data.customer_title,
          customers: customers,
          office_title: data.office_title,
          offices: offices,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          setIsLoading(false);
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_ABOUTUS,
        {
          title: data.title,
          description: data.description,
          introImage: introImage,
          story_title: data.story_title,
          stroy_description: data.stroy_description,
          story_image: story_image,
          timeline: timeline,
          mission_title: data.mission_title,
          mission_description: data.mission_description,
          mission_image: missionImage,
          values_title: data.values_title,
          values: values,
          team_title: data.team_title,
          team_description: data.team_description,
          // award_title: data.award_title,
          // award_description: data.award_description,
          // awards: awards,
          customer_title: data.customer_title,
          customers: customers,
          office_title: data.office_title,
          offices: offices,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // console.log("isEmpty>>>", isEmpty);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {isLoading && <Loading />}
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">About Us Page</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <h5>Intro Section</h5>
                <hr />
                <div className="mb-3 row">
                  <div className="col-md-2">
                    {introImage ? (
                      <div
                        className="client_image_inner"
                        style={{ position: "relative" }}
                      >
                        <img
                          src={introImage}
                          alt={"About Us Image"}
                          style={{ width: "100%" }}
                        />
                        <span
                          className="closeIcon"
                          onClick={() => setIntroImage(null)}
                        >
                          <i className="ri-close-line"></i>
                        </span>
                      </div>
                    ) : (
                      <div className="add_client_btn">
                        <input
                          type="file"
                          className="upload_hidden"
                          onChange={(e) => uploadIntroImage(e)}
                        />
                        <div>
                          <span className="icn">
                            <i className="ri-add-line"></i>
                          </span>
                          <h5 className="title">Choose Image</h5>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <label>
                    Heading(H1){" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.title?.length} / 20)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("title", { required: true })}
                    placeholder="Enter title"
                  />
                  {errors.title && (
                    <span className="text-danger">Title is required</span>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.description?.length} / 350)
                    </small>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    {...register("description", { required: true })}
                    placeholder="Enter description"
                  />
                  {errors.description && (
                    <span className="text-danger">Description is required</span>
                  )}
                </div>
                <h5>Our Story Section</h5>
                <hr />
                <div className="row">
                  <div className="col-md-8">
                    <div className="mb-3">
                      <label>
                        Title{" "}
                        <small className="text-muted" style={{ opacity: 0.5 }}>
                          ({allFields?.story_title?.length} / 15)
                        </small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("story_title", { required: true })}
                        placeholder="Enter title"
                      />
                      {errors.story_title && (
                        <span className="text-danger">Title is required</span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label>
                        Description{" "}
                        <small className="text-muted" style={{ opacity: 0.5 }}>
                          ({allFields?.stroy_description?.length} / 700)
                        </small>
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        {...register("stroy_description", { required: true })}
                        placeholder="Enter description"
                        style={{ resize: "none" }}
                      />
                      {errors.stroy_description && (
                        <span className="text-danger">
                          Description is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    {story_image ? (
                      <div
                        className="client_image_inner"
                        style={{ minHeight: 180, position: "relative" }}
                      >
                        <img
                          src={story_image}
                          alt={"Image"}
                          style={{ width: "100%", maxHeight: 180 }}
                        />
                        <span
                          className="closeIcon"
                          onClick={() => setStoryImage(null)}
                        >
                          <i className="ri-close-line"></i>
                        </span>
                      </div>
                    ) : (
                      <div
                        className="add_client_btn"
                        style={{ minHeight: 180 }}
                      >
                        <input
                          type="file"
                          className="upload_hidden"
                          onChange={(e) => uploadStoryImage(e)}
                        />
                        <div>
                          <span className="icn">
                            <i className="ri-add-line"></i>
                          </span>
                          <h5 className="title">Choose Image</h5>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <h5>Our Story Timeline</h5>
                <hr />
                {timeline.map((item, index) => (
                  <div className="row mb-3" key={`timeline${index + 1}`}>
                    <div className="col-md-11">
                      <div className="row">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Year"
                            name="year"
                            value={item.year}
                            onChange={(e) => handleTimeLineInput(e, index)}
                          />
                        </div>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Description"
                            name="title"
                            value={item.title}
                            onChange={(e) => handleTimeLineInput(e, index)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1">
                      <button
                        className="btn btn-danger"
                        type="button"
                        style={{ width: "100%" }}
                        onClick={() => removeTimeLine(index)}
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                ))}
                <hr />
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={() => addTimeLine()}
                  >
                    Add new timeline
                  </button>
                </div>
                <h5>Our Mission Section</h5>
                <hr />
                <div className="row">
                  <div className="col-md-8">
                    <div className="mb-3">
                      <label>
                        Title{" "}
                        <small className="text-muted" style={{ opacity: 0.5 }}>
                          ({allFields?.mission_title?.length} / 16)
                        </small>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("mission_title", { required: true })}
                        placeholder="Enter title"
                      />
                      {errors.mission_title && (
                        <span className="text-danger">Title is required</span>
                      )}
                    </div>
                    <div className="mb-3">
                      <label>
                        Description{" "}
                        <small className="text-muted" style={{ opacity: 0.5 }}>
                          ({allFields?.mission_description?.length} / 700)
                        </small>
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        {...register("mission_description", { required: true })}
                        placeholder="Enter description"
                        style={{ resize: "none" }}
                      />
                      {errors.mission_description && (
                        <span className="text-danger">
                          Description is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    {missionImage ? (
                      <div
                        className="client_image_inner"
                        style={{ minHeight: 180, position: "relative" }}
                      >
                        <img
                          src={missionImage}
                          alt={"Image"}
                          style={{ width: "100%", maxHeight: 180 }}
                        />
                        <span
                          className="closeIcon"
                          onClick={() => setMissionImage(null)}
                        >
                          <i className="ri-close-line"></i>
                        </span>
                      </div>
                    ) : (
                      <div
                        className="add_client_btn"
                        style={{ minHeight: 180 }}
                      >
                        <input
                          type="file"
                          className="upload_hidden"
                          onChange={(e) => uploadMissionImage(e)}
                        />
                        <div>
                          <span className="icn">
                            <i className="ri-add-line"></i>
                          </span>
                          <h5 className="title">Choose Image</h5>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <h5>Our Values Section</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Section Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.values_title?.length} / 25)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("values_title", { required: true })}
                    placeholder="Enter section title"
                  />
                  {errors.values_title && (
                    <span className="text-danger">
                      Section title is required
                    </span>
                  )}
                </div>
                {values.map((value, index) => (
                  <div className="row mb-3" key={`values${index + 1}`}>
                    <div className="col-md-11">
                      <div className="row">
                        <div className="col-md-6">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter title"
                            name="title"
                            value={value.title}
                            onChange={(e) => handleValuesInput(e, index)}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter description"
                            name="description"
                            value={value.description}
                            onChange={(e) => handleValuesInput(e, index)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1">
                      <button
                        className="btn btn-danger"
                        type="button"
                        style={{ width: "100%" }}
                        onClick={() => removeValues(index)}
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                ))}
                <hr />
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={() => addValues()}
                  >
                    Add value
                  </button>
                </div>
                <h5>Our Team Section</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Section Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.team_title?.length} / 25)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("team_title", { required: true })}
                    placeholder="Enter section title"
                  />
                  {errors.team_title && (
                    <span className="text-danger">
                      Section title is required
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <label>
                    Section Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.team_description?.length} / 350)
                    </small>
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    {...register("team_description", { required: true })}
                    placeholder="Enter section description"
                  />
                  {errors.team_description && (
                    <span className="text-danger">
                      Section description is required
                    </span>
                  )}
                </div>
                {/* <h5>Awards Section</h5>
                <hr />
                <div className="mb-3">
                  <label>Section Title</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("award_title", { required: true })}
                    placeholder="Enter section title"
                  />
                  {errors.award_title && (
                    <span className="text-danger">
                      Section title is required
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <label>Section Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    {...register("award_description", { required: true })}
                    placeholder="Enter section description"
                  />
                  {errors.award_description && (
                    <span className="text-danger">
                      Section description is required
                    </span>
                  )}
                </div>
                {awards.map((award, index) => (
                  <div className="row mb-3" key={`awards${index + 1}`}>
                    <div className="col-md-11">
                      <div className="row">
                        <div className="col-md-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter year"
                            name="year"
                            value={award.year}
                            onChange={(e) => handleAwardsInput(e, index)}
                          />
                        </div>
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter title"
                            name="title"
                            value={award.title}
                            onChange={(e) => handleAwardsInput(e, index)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1">
                      <button
                        className="btn btn-danger"
                        type="button"
                        style={{ width: "100%" }}
                        onClick={() => removeAwards(index)}
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                ))}
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={() => addAward()}
                  >
                    Add new award
                  </button>
                </div> */}
                <h5>Our Customer Section</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Section Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.customer_title?.length} / 25)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("customer_title", { required: true })}
                    placeholder="Enter section title"
                  />
                  {errors.customer_title && (
                    <span className="text-danger">
                      Section title is required
                    </span>
                  )}
                </div>
                <div className="clients_wrapper">
                  <div className="row">
                    {customers.map((client, index) => {
                      return (
                        <div className="col-md-2" key={`client${index + 1}`}>
                          <div className="client_image_inner">
                            <span
                              className="closeIcon"
                              onClick={() => handleRemoveCustomer(index)}
                            >
                              <i className="ri-close-line"></i>
                            </span>
                            <img src={client} alt={`client${index + 1}`} />
                          </div>
                        </div>
                      );
                    })}
                    <div className="col-md-2">
                      <div className="add_client_btn">
                        <input
                          type="file"
                          className="upload_hidden"
                          onChange={(e) => uploadCutomerImage(e)}
                        />
                        <div>
                          <span className="icn">
                            <i className="ri-add-line"></i>
                          </span>
                          <h5 className="title">Add New Customer</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h5 className="mt-3">Our Offices Section</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Section Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.office_title?.length} / 25)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("office_title", { required: true })}
                    placeholder="Enter section title"
                  />
                  {errors.office_title && (
                    <span className="text-danger">
                      Section title is required
                    </span>
                  )}
                </div>
                {offices.map((item, index) => (
                  <div className="row mb-3" key={`office${index + 1}`}>
                    <div className="col-md-11">
                      <div className="row">
                        <div className="col-md-3">
                          {item.image ? (
                            <div
                              className="client_image_inner"
                              style={{
                                backgroundColor: "#999999",
                                padding: 20,
                                borderRadius: 5,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                              }}
                            >
                              <img src={item.image} alt={item.title} />
                              <span
                                className="closeIcon"
                                onClick={() => removeOfficeImage(index)}
                              >
                                <i className="ri-close-line"></i>
                              </span>
                            </div>
                          ) : (
                            <div className="add_client_btn">
                              <input
                                type="file"
                                className="upload_hidden"
                                onChange={(e) => uploadOfficeImage(e, index)}
                              />
                              <div>
                                <span className="icn">
                                  <i className="ri-add-line"></i>
                                </span>
                                <h5 className="title">Add office icon/image</h5>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="col-md-9">
                          <div className="row">
                            <div className="col-md-6">
                              <textarea
                                type="text"
                                className="form-control"
                                placeholder="Enter office address"
                                name="address"
                                value={item.address}
                                onChange={(e) => handleOfficesInput(e, index)}
                                style={{ height: "150px", resize: "none" }}
                              />
                            </div>
                            <div className="col-md-6">
                              <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter office title"
                                name="title"
                                value={item.title}
                                onChange={(e) => handleOfficesInput(e, index)}
                              />
                              <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter office phone"
                                name="phone"
                                value={item.phone}
                                onChange={(e) => handleOfficesInput(e, index)}
                              />
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter office email"
                                name="email"
                                value={item.email}
                                onChange={(e) => handleOfficesInput(e, index)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1">
                      <button
                        className="btn btn-danger"
                        type="button"
                        style={{ width: "100%" }}
                        onClick={() => removeOffice(index)}
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                ))}
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={() => addOffice()}
                  >
                    Add new office
                  </button>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <button className="btn btn-primary" type="submit">
                  Save Info
                </button>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Aboutus;
